export const red = [
  {
    artist: "Rage Against the Machine",
    id: "F9S-JVKw0mE",
    comments: [
      "Zach's anger is a gift to humanity.",
      "Rage makes me wanna flip a cop car",
      "RAGE AGAINST THE MACHINE IS MODERN DAY THERAPY TO MY EARS.",
      "I tried telling my mom what they were singing at the end but she smashed me with a wooden spoon.",
      "I actually feel sorry for Metallica who had to play after them.",
      "Some of the most important music ever written. These guys give every ounce of energy they can give.",
      "There's never been a band like RATM, they're one of a kind. One of the greatest of all time.",
      "We need a little Rage right now. This is for the people of the Sun.",
      "de la Rocha is one of the greatest rappers of all time, but because he does it in a rock format, you never his name mentioned.",
      "Governments invented covid19 to stop ratm tours",
    ],
  },
  {
    artist: "Korn",
    id: "jR88BgYMlbQ",
    comments: [
      "Are you READY!?!",
      "Crowd turns into Liquid",
      "I wonder how many people went with their friends, went crowd surfing and then could never find the people they came with after that",
      "and this is how the 90s said goodbye",
      "David Sylveria was a sick drummer.",
      "A crowd with no phones, that's something you'll never see again :(",
      "munkys frog leap dance move",
      "not gonna lie, I'll always miss the 80s and 90s",
      "Falling Away From Me was really sick.",
      "They're one of the literal best bands ever.",
    ],
  },
  {
    artist: "Korn",
    id: "NpSKLOjC0ts",
    comments: [
      "damn this music reminds me of not doing homework, playing n64, drinking orange soda, coming inside from rollerblading",
      "late 90's nu metal era is forever the shit.",
      "Iphone free crowd. Those were the days. Proper mosh pit too!",
      "THAT MOUSTACHE.",
      "Dave Silveria is so underrated.",
      "THE days of Adidas vs Puma.",
      "PA/Sound was amazing!  The guitars, amps and pedals, everything was perfect.  That bit with Ice Cube was amazing.",
      "Can't explain the feeling of listening to korn songs <3",
      "Munky getting really into it",
      "Silveira's chops so intense, them sudden blasts..",
    ],
  },
  {
    artist: "Korn",
    id: "toBpygISzeM",
    comments: [
      "Why do people record when there are professional recordings only a few days after, they ruin the shows",
      "I think Brixton Academy is one of my favourite concerts the sound is so much better cause it is indoors and small and the drums and guitars sound way better there than most concerts.",
      "The energy it must take for JD to belt out these vocals for an entire show....fukn impressive!",
      "This is sad, Get rid of them phones and have a good time!",
      "I still love KoRn!",
      "I love that I can name every song from every concert haha",
      "My favourite band till the day I die.",
      "dead bodies everywhere!!!",
      "my dream watching KORN concert :-(",
      "Dave Mustaine xD",
    ],
  },
  {
    artist: "Queen",
    id: "SbWLWNXsVxA",
    comments: [
      "This cleared my acne, cured my depression, and gave me good grades",
      "All songs of Queen are great",
      "He truly was in a league of his own.  His live performances where just out of this world.  Nobody will ever come close to this mans ability",
      "There’s a love affair going on between Freddie and his audience, both ways.",
      "I’ve been told I’m obsessed with Queen and Freddie. Uh yeah !!!!",
      "I couldn’t stop looking at Deaky, he’s just so mesmerising",
      "Freddie Mercury is a total performer ever in the history of music",
      "Nobody talks about Freddie's good shape. Did he workout? what a great body!",
      "Oh my god. They were and are amazing. Freddie was beyond incredible.  I’m in awe.",
      "THE BEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEST",
    ],
  },
  {
    artist: "Hives",
    id: "e2f0Ff2cfQY",
    comments: [
      "such a underrated band",
      "Damn, that drummer gets one hell of a cardio workout...",
      "This is a perfect example of how every musician should act, BE ACE AND HAVE A BLOODY GOOD TIME",
      "Damn, these guys are amazing live.",
      "Gentlemen doing punk",
      "music's missing danger, but these guys are doing a good job roughing it up",
      "That bass is fuzzrocious",
      "Something is wrong with his microphone... at first I thought it is still turned off, but maybe it is too quiet because the others sound much louder... weird o.O",
      "That was a great performance!",
      "clockwork orange",
    ],
  },
  {
    artist: "Hives",
    id: "4d_xk7sSIbU",
    comments: [
      "Maybe one of the most underrated frontmen and live acts since the 80s, swear down",
      "The Hives are when The Stooges, Pixies, The B 52's, The Clash and DEVO all have an overly mischievous musical baby they will have to eventually put on Ritalin. Too much fun!",
      "Good lord, what a HOT CROWD!  So many concerts nowadays, people just stand silent.  These gents are what live music is all about",
      "I love the insane style of Nicholaus Arson.",
      "Sometimes i'm really proud of being a swede. Best live band ever, Fagersta finest.",
      "Good performance",
      "The Hives in their prime!",
      "still the best live band in the world!",
      "THIS IS ROCK AND ROLL THIS IS THE HIVES",
      "ohh boy",
    ],
  },
  {
    artist: "Papa Roach",
    id: "4w_OVYeea6c",
    comments: [
      "Respect  to Papa Roach. So many years playing and they still show so much energy!",
      "This man to this day still sings his heart out, so proud to be a fan.",
      "The crowd is too calm at the beggining. And Jakob awake them ... nice job",
      "I'm really pleased with this one. Hair was on point",
      "Shaddix is a monster",
      "This is one of the best Papa Roach's perfomances I've seen in  while! Also Anthony is doing an amazing job.",
      "how the hell does he sounds so good for so long, this guy is a rare gem",
      "Jacoby is the best front man of a generation, always on point.",
      "Take my moneeeeey!",
      "They still rock!!! Great sound!  awesome!!",
    ],
  },
  {
    artist: "Papa Roach",
    id: "CFecEDvIxok",
    comments: [
      "Mixing guy is a bassist.",
      "Papa Bass - i like",
      "Its like im hearing the guitar from a phone speaker and the bass super boosted",
      "Good band  ; )  let's rock",
      "Last Resort",
    ],
  },
  {
    artist: "Linkin Park",
    id: "7Mxg4VkkRRI",
    comments: [
      "I WENT WITH MY MOM! THANKS MOM!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
      "This is the best concert of their entire career.",
      "Whenever Chester screams, the crowd just go Crazy . What a power .",
      "So goddamn perfect it sounds like a studio recording",
      "This was his prime. The power and the raspy voice at the same time.",
      "How does chester sing like that for a whole concert? crazy",
      "Chester one of those people who sound better live",
      "Cant believe how good Chesters voice is live. Crazy.",
      "One of the few bands that I will always think sound better live",
    ],
  },
  {
    artist: "Linkin Park",
    id: "VEljwjZen-A",
    comments: [
      "There's no doubt this was one of Chesters best vocal performances. The stars aligned for him that night. True art here.",
      "Greatest band of all time.Wish i could have seen them in concert with chester live.",
      "My favourite band ever",
      "This concert is chester's legacy",
      "So beautiful sound",
      "This is one of the best performances i've ever seen",
      "Unbelievable. I have a background in classical voice and I'm a professional pianist.  His voice endurance is arguably the greatest of all time.",
      "Watching these LP live shows makes me cry",
      "Chesters voice was on point in this concert",
      "MY GOD THIS IS GOOD---WISH I WAS THERE!",
    ],
  },
  {
    artist: "AC/DC",
    id: "lfSWQtCpEFk",
    comments: [
      "“We don’t speak spanish very well but we speak rock n’ roll very good”",
      "it’s one of my favourite live concerts ever! Brilliant stuff!",
      "This crowd is FUKIN Insane!",
      "THE BIGGEST CONCERT IN HISTORY TO TAKE PLACE AT A SECOND DIVISION CLUB STADIUM",
      "The greatest Rock and Roll band EVER And what a concert",
      "And God Said: Let There Be Rock!",
      "River Plate is the ultimate audience for any rock band.",
      "And this, kids, is what real music means. Listen and learn.",
      "Ac dc live at circus krone full.",
      "This is exectley what Human beeing is about. Love it",
    ],
  },
  {
    artist: "AC/DC",
    id: "epSe9V5ngeo",
    comments: [
      "bon scott ... best hard rock vocalist of all time... in my opinion",
      "Bon Scotts jeans had to be surgically removed after the show.",
      "True legends of rock",
      "my mom was always blasting acdc when I was little, thanks mom!",
      "Angus Young jumping all around on stage with his guitar yet keeping perfect control...always impresses",
      "One of my first concerts.",
      "Angus has some of the best vibrato I've ever heard.",
      "Goddam Bon Scott was the real deal!",
      "Bon Scott probably made groupies pregnant just by looking at them.",
      "Damn Bon could sing like a beast live.",
    ],
  },
  {
    artist: "Slipknot",
    id: "QO3j9niG1Og",
    comments: [
      "Why does Corey’s mask make him look like a scary Ed Sheeran in this?",
      "the only harmless thing in this concert is the giraffe",
      "Corey’s voice is a lot better now than on the gray chapter era",
      "AAAAAAAARRRRGGGGGGHHHHHH",
      "Corey’s mask is what I look like when my allergies struck",
      "Coreys mask looks like it has melted into his face",
      "Slipknot are like wine The more it ages, the more is good",
      "You can tell how proud Corey is of his screams, he’s practically grinning the whole concert.",
      "Corey don't need autotune, autotune needs him.",
      "The VOCALS are out of this WORLD!",
    ],
  },
  {
    artist: "Metallica",
    id: "zFJ4H0t7dWs",
    comments: [
      'Bleeding Me" is such a beautiful song. And quite underrated too.',
      "Who’s hoping for Kirk or James to do the intro this time?",
      "they need to play bleeding me again. absolutely one of their BEST songs",
      "Hetfield looking great here. Goatee James is underrated.",
      "Metallica has insane luck with bassists",
      "We need more bleeding me in Setlists",
      "Metallica is my therapy.  So  happy they exist, the earth would be a lesser place without them.",
      "Creeping Death will forever be the best opener",
      "The best band of the world. My friends forever ...",
      "Devils Dance was definitely the surprise of this show",
    ],
  },
  {
    artist: "Metallica",
    id: "mJje9Xpp5GE",
    comments: [
      "One of Metallica’s greatest accomplishments is  how they’ve managed to appeal to the same age group decade after decade while also retaining their aging fanbases. What a timeless band!!!",
      "This was an absolutely kick ass show.",
      "First gig I went to after kicking cancer's ass where I had energy for the whole set.",
      "It’s so cool seeing the raindrops fly everywhere when Lars plays his drums!",
      "That little solo in St. Anger was more unexpected than the Spanish inquisition",
      "The more pressure there is on Metallica, the better they play.",
      "I still can’t get over how badass master of puppets was",
      'THAT EXTENDED VERSION OF "MEMORY" IS SUPER COOL !!!',
      "Props to Trujjillo for not dying his grey.",
      "When playing 'One' and trenchfoot is an actual possibility",
    ],
  },
  {
    artist: "Metallica",
    id: "pjGYBktU71I",
    comments: [
      "The era when James went full trailer trash, Kirk looked like Michael Jackson, and Jason was just a head banging neck.",
      "I call this haircut on James, “The Kentucky Gentleman”",
      "couple of good rare ones on the setlist, can't believe they played Enter Sandman",
      "Is it just me or does Newsted make everything better.",
      "Jason Newsted was just perfect match for the band",
      "50% of the metal energy in concert is due to Jason.",
      "It would be nice if James and Kirk would crawl out of the hole they're hiding in and introduce one of these shows!",
      "The God that failed , proshot in 1994 , finally",
      "This was peak James hairstyle. So badass",
      "Jason Newsted Forever",
    ],
  },
  {
    artist: "Nine Inch Nails",
    id: "LBC3NXnN8y4",
    comments: [
      "Trent Reznor is the proof you don't need tattoos or piercings to be cool.",
      "Thank you Trent.",
      "That drummer is absolutely killing it.",
      "Trents looks 40.  Mick Jagger looks 1,000.",
      "The bass is so good especially with a nice set or headphones, they were on their shit this night",
      "absolutely love how the world keeps changing but his stage still looks like a map from Quake.",
      "That bass player just went to play bass. He never moved.",
      "How about that drummer?",
      "Who the Hell is this amazing drummer? Crazy energy",
      "Back up singer is Lisa Fischer...",
    ],
  },
  {
    artist: "Green Day",
    id: "dO-Y_fMuc4c",
    comments: [
      "Billie is the only middle aged man in the world that could still pass as a teenager",
      "Green Day are always so damn amazing live!",
      "Billie Unlocks Double Jumping",
      "I admire everyone today who still loves new and old green day",
      "Billie is the only middle aged man that vendors asks for ID when buying alcohol...",
      "Who ever mixed this you are a god",
      "Billie forgot his eyeliner",
      "Looks epic!",
      "Revolution Road :/",
      "Come on billie, where's When i come around?!",
    ],
  },
  {
    artist: "Liam Gallagher",
    id: "37BDUBe6Tfg",
    comments: [
      "All the Oasis tunes sound better when Bonehead is on the guitar.",
      "Bonehead: The only guy in his 50s who can pull off wearing an adidas tracksuit.",
      "Ive just realised bonehead was what I liked about Oasis's sound",
      "Liam seems to feel more confident with Bonehead on stage. He should play permanently. We have 2/3 of Oasis there.",
      "Has there ever been a cooler man to play the tambourine",
      "Nobody is gonna say something about Sad Song? Greatest live version ever",
      "Looks like Bonehead has given Liam's band a lesson or two...",
      "Liam doesn't need Noel But Liam needs Bonehead !!!!",
      "Can’t have enough Bonehead’s comments. He’s fkin LEGEND",
      "Noel needs Liam so much more than Liam needs Noel.",
    ],
  },
  {
    artist: "Liam Gallagher",
    id: "EnzVduS-vyE",
    comments: [
      "biblical",
      "Best liams been in 20 years! The man is back.",
      "The Rock N Roll is Liam Gallagher.",
      "Liam is on absolute fire!",
      "Epic and BIBLICAL!! It's historic!!",
      "Amazing , John Lennon reincarnated",
      'Bang on, "gone" was amazing',
      "Gone is a huge tune!",
      "One word only: EPIC!",
      "Once is one hell of a song",
    ],
  },
  {
    artist: "Noel Gallagher's High Flying Birds",
    id: "WyYWRrqLOSA",
    comments: [
      "Noel just seems to get better and better as a singer, songwriter and guitarist. Such a legend.",
      "Man who built the moon is a tune",
      "Liam is an entertainer, Noel is an artist",
      "´Alone on the rope´ should be on an album. Genius",
      "Awesome I cant believe he played alone on the rope",
      "I love how Gem plays the guitar!!",
      "Alone On The Rope is such an incredible song.",
      "This man is GOD.",
      "Fort Knox is the perfect opening tune for a live performance!",
      "Really respect Noel as an artist, love him!",
    ],
  },
  {
    artist: "Noel Gallagher's High Flying Birds",
    id: "BbEEcP79IDI",
    comments: [
      "NGHFB are amazing!",
      "Pretty cool that he uses the Adidas J-200 for the Oasis numbers",
      "Yeah baby yeah!",
    ],
  },
  {
    artist: "Noel Gallagher's High Flying Birds",
    id: "GnnfXPJxnCo",
    comments: [
      "Only Noel can open a show with a B side. Brilliant....",
      "If Oasis gets back together, they're going to make one of the best albums ever. Both Noel and Liam are on fire.",
      "Never understood why people use their phones to record a gig which is being recorded with TV cameras.",
      "This audio is stunning. Well done. Also, this performance is the reason why Oasis won't reform. Noel is on fire at the moment.",
      "Noel hasn't lost it. The voice isn't any different from the recorded tunes, if not better.",
      "This is arguably one of Noel's best sets. And it also pretty much says oasis are done. He doesn't need them.",
      "This sounds absolutely incredible. Unreal Audio, Noel never disappoints like.",
      'And Liam said Noel was the "weird" one.  Maybe Liam is an alien.',
      "Everybody's On The Run, The Dying Of The Light and If I Had A Gun gave me goose bumps...",
      "I can't think of anyone else who still writes songs like this.",
    ],
  },
  {
    artist: "Foo Fighters",
    id: "jcwBsntqjmY",
    comments: [
      "The fact they got Jimmy Page and John Paul Jones is the coolest thing ever",
      "One of the best shows all time.",
      "A concert without smartphones, that must be crazy.",
      "Dude, where are you going?",
      "When Dave sings he looks like he’s riding a horse",
      "The best show I've ever seen.",
      "Dave is my new god, after Frusciante, but who knows... OMG love this guy sooo much. Btw drummer is amazing too. Nope, Dave IS the best!",
      "Time to fight the foo",
      "Times like these makes me wanna cry",
      "whenever i saw Pat playing...i see happiness",
    ],
  },
  {
    artist: "Foo Fighters",
    id: "A8z6rbmx7Mg",
    comments: [
      "Short haired Dave scares me",
      "The mix is absolutely insane, might be the heaviest live recording of theirs I've ever heard",
      "The foos never disappoint.",
      "This show is incredible",
      "They should play In Your Honor and DOA more often!!!",
      "Taylor with short hair Looks like a member of the bee gees",
      "It's times like these you learn to live again...",
      "One of the best groups ever",
      "Still My favorite all time band.",
      "One of the most awesome shows ever",
    ],
  },
  {
    artist: "Red Hot Chili Peppers",
    id: "PNd7cRl6Bfg",
    comments: [
      "This is the very first show of their Californication tour",
      "Emit remmus is a great opening",
      "Slap in you face!!",
      "that frusciante fuzzy tone is amazing!",
      "Amazing quality!",
      "best performance of power of equality.",
      "Oooooooouhhhh how off was Frusciante in Around the World hahahaha",
      "Temp rising and the heat intensifies",
      "John frusciante feeling",
      "Got scared when I saw flea up close sigh",
    ],
  },
  {
    artist: "Guns N' Roses",
    id: "UTulnklNm2Q",
    comments: [
      "I can’t believe SLASH is 54 years old.",
      "Axl sounds more like mickey.",
      "If Axl had stuck with his Brownstone voice on Slither , it would have been epic!",
      "The Best Band in the worl !!",
      "Oh, the old good times when we could rock outside...",
      "I’m impressed that Axl did this song.  Slither I mean.",
      "Axl would sound so much better if he just went down an octave.",
      "When your bassist sounds better than the lead singer.",
      "They should do these every Monday like Metallica.",
      "Axl is awesome but slash carried the show i havent see him so energetic for a long time",
    ],
  },
  {
    artist: "Sex Pistols",
    id: "QBVDSz5Qd6g",
    comments: [
      "This sounds so bad and so damn good at tha same time. Legends",
      "Johnny Rotten is an incredible front man, sarcastic, cynical and with a very original voice, he is the joker on the stage",
      "I can't complain. Sid's bass playing skills are wayyy better than mine lmao",
      "drummer deserves more credit than he got...",
      "i don't care what the general consensus is, I love this show.",
      "johnny looks like he wishes he was in pink floyd.",
      "John Lydon. One of the legendary Voices.",
      "It's a miracle they got through this one hour show still standing up.",
      "For a guy who can’t play bass, „not even a bit“ Sid‘s playing is pretty solid.",
      "Pretty vacant has got to be one of the best songs ever written.",
    ],
  },
  {
    artist: "Lou Reed",
    id: "yOoXjYppyMM",
    comments: [
      "Lou Reed had really amazing posture.",
      "We need more volume to Mr. Robert Quine, please",
      "Robert Quine on Lead Guitar!!!",
      "Lou Read is one of the most underrated artists ever.",
      "Makes my day. R&R sure is fun!",
      "He's actually happy",
      "...her life was saved by rock n roll",
      "I can die peacefully having seen this dude (and band)  live",
      "Man his voice sounds just fine. Usually at this point you'd notice some weakness.",
      "Incredible.",
    ],
  },
  {
    artist: "Grateful Dead",
    id: "VnCvS2A7REo",
    comments: [
      "There is literally NOTHING better than a happy Jerry Garcia.",
      "Stay gold, Brent.",
      "May the wings of Angels surround and protect you like the softest warmest blanket you have ever felt.",
      "Imagine that! Bobby with Bobbie pins in his hair",
      "Turn off your mind, relax and float down stream...",
      "This is an excellent show....best “eyes” ever...& “he’s gone” on point!",
      "This concert changed my life.",
      "My goodness the boys were hot tonight.",
      "With a doubt! Nothing like a Jerry smile to make everything perfect!",
      "That was Awesome....",
    ],
  },
  {
    artist: "Sum 41",
    id: "DTIKGtUbRqU",
    comments: [
      "This just proves that small venues are the best for the band and crowd interaction.",
      "Props to the sound guy. This sounds AMAZING!",
      "It's great to see Deryck back after all that shit! Thanks man!!",
      "Whoever mixed the audio is a God those drums sound amazing!!!!",
      "This is what a concert is about, the band and crowd having a good time",
      "These guys were always a very different breed than the average pop-punk Mtv fodder bands of the early millennium.",
      "These guys are like wine, the older they gets the better they are!",
      "Now this is a great crowd: no phones and enjoying the moment.",
      "The sound quality of this recording is incredible",
      "That new song sounds even better live!",
    ],
  },
  {
    artist: "Sum 41",
    id: "6F7qretnMAs",
    comments: [
      "Epic drumstick fail",
      "First three records are classy and flawless.",
      "oh god that fat lip intro was spot on",
      "nostalgia",
      "I wish the bass was louder",
      "That random Slayer cover cracked me up, I believe Brownsound is a huge Thrash fan, I got his solo CD with his brother very good shit!",
      "someone likes slayer",
      "This is cool",
      "Aha wrong lyrics during rhythms that's cool",
      "Ahhhhh back when they were cool",
    ],
  },
  {
    artist: "My Chemical Romance",
    id: "Ud2eziOjjTo",
    comments: [
      "when my chemical romance is more active than twenty one pilots",
      "STILL THE BEST BAND EVER !",
      "I'm not a hero\" is one of the most incorrect things Gerard Way has said.",
      "This is the closest i will ever be to an mcr concert...",
      "WHEN GERARD CHICKEN DANCED AROUND THE STAGE WHEN RAY WAS DOING HIS SOLO DURING TEENAGERS",
      "Forever thinking about how Frank stayed onstage to watch Gerard sing the last song",
      "I can’t comprehend how some people don’t like mcr. They are perfect.",
      "Anyone else notice gerard's chicken sance during teenagers?",
      "I’m simping so hard for Gerard in this concert",
      "This is gotta be Gerard's best look",
    ],
  },
  {
    artist: "Paul McCartney",
    id: "1QGxFpSb6Sc",
    comments: [
      "He’s nearly 80 and he can still perform Helter Skelter. One statue does not do Paul McCartney justice.",
      "Linda would be proud.",
      "The word LEGEND doesn't do Paul McCartney justice. The greatest of all times!",
      "Who is complaining about his voice !!!",
      "We  are all blessed to  have Paul McCartney in our life's",
      "The Greatest Songwriter Who Ever Lived, and lives.",
      "You are great Paul. A living legend of rock.",
      "I still can't believe how good his voice sounds at 76!! Incredible!!!!",
      "The oldest songs sound so fresh and so beautiful, simple and authentic. They sound like an eternal spring.",
      "THE MUSIC OF THE BEATLES / PAUL MC CARTNEY IS IMMORTAL!",
    ],
  },
  {
    artist: "Queens of the Stone Age",
    id: "79yiz_Zb7fE",
    comments: ["epic!", "I agree, one of the best lineup."],
  },
  {
    artist: "Queens of the Stone Age",
    id: "ExGw382UGZU",
    comments: [
      "Being a drummer in a QOTSA'S show is equivalent to running a marathon",
      "Better Living is such an under used and underrated jam",
      "Man! The sound of this gig is delicious!",
      "Such a great performance, QOTSA one of the best live performers in the business",
      "This version of better living is the best I’ve ever heard!!! Mad props",
      "What a great show!! One of their best for sure!",
      "amazing performance as always !!",
      "The definitive setlist!!!!  WOOOOOOOW",
      "this is the best!",
      "I had the pleasure to be there. Great gig!",
    ],
  },
  {
    artist: "Pixies",
    id: "KsxNpBou1Ts",
    comments: [
      "Pixies is one of the best bands ever. It changed rock music.",
      "Hell yes!",
      "Long live to the KingS",
      "Wowowo",
    ],
  },
  {
    artist: "Imagine Dragons",
    id: "NapLxHp09DU",
    comments: [
      "The only band that is much better in live performances",
      "It's great how happy he is with jumping and hopping around the podium",
      "When his fans know the lyrics better than him xD",
      "he's actually wearing a shirt what the heck",
      "I always wish you could perform Monster and Warriors, these two songs are gold to me ♥️",
      "I love Imagine Dragons soo much. The passion and love put into their songs, and the joy on their faces when they're on stage just makes me so happy.",
      "I nearly cried from Dan Reynolds speech during Demons.",
      "Don't we all wish we were a rockstar singer like dan",
      "I swear, anyone could propose to me at an Imagine Dragons Concert and I'd say yes.",
      "I teared up when demons started",
    ],
  },
  {
    artist: "Imagine Dragons",
    id: "M96oleMSx-c",
    comments: [
      "only person in my school and my family that enjoy IMAGINE DRAGONS",
      "Best band ever!! I love how they don't put all kinds of trash and junk into their lyrics like everyone else. They are a one of a kind band, my personal favorite band ever.",
      "Wow i was a casual imagine dragons fan before, just knowing their radio songs, but after seeing them performing live last thursday, i fel in love with them!",
      "Dan is making me want to purchase everything he has ever made, what an amazing guy!",
      "The happiness in Dan's face is like the best. Me da vida we",
      "Dan has the most adorable smile I have ever seen",
      'The bass solo before "Amsterdam" is just amazing',
      "IMAGINE DRAGONS DOMINATING THIS WORLD!!!❤",
      "I love Imagine Dragons so much that I seriously don't care whether they performed many songs from their new album or not. :)",
      "My daughter is obssed with this band. She made it her goal to learn all the lyrics all there songs.",
    ],
  },
  {
    artist: "Imagine Dragons",
    id: "Iz3ETf0Fqys",
    comments: [
      "This guys never change IMAGINE DRAGONS NEVER CHANGE ♥️",
      "best band ever, I love their songs they convey love and that's amazing ....",
      "we always need to appreciate how amazing imagine dragons is live",
      "They are such a good band to see live!",
      "I’m learning believer on my violin",
      "I love imagine dragons",
      "Excelente simplemente increible!!!",
      "I'm still grateful for thunder",
      "You are really amazing!!! Love you guys!!!",
      "great band, great direct",
    ],
  },
  {
    artist: "Bloc Party",
    id: "aaVnpfAqCXg",
    comments: [
      "kele needs to stop skipping leg day",
      "Kele.Singing indy is really great. And the music of the band has a creative idea to progress, there is something new to listen.",
      "Different music,and member,this girl not bad at drummer,go Bloc Party",
      "Shoutout to everyone with me in the moshpit at the front",
      "Amazing band.",
      "what a bangin set. awesome",
      "Shreded Kele is Shredding the guitar",
      "Masterpiece.",
      "i have to admit that its actually a good performance...",
      "best!",
    ],
  },
  {
    artist: "Bloc Party",
    id: "8nOsuuhQd1o",
    comments: [
      "Bloc party is a powerful band because of Matt Tong",
      "Idc what anyone says, Four was awesome",
      "Team A is so raw and pure, i love the energy of all four!!",
      "Awesome, but does anyone else feel as if almost every song is slightly out of control?",
      "Love it! Just hate that Kele doesn't sing the original lyrics for disappear here at the beginning of the song.",
      "wow amazing  ♥ ♥ ♫ 100% power",
    ],
  },
  {
    artist: "Spoon",
    id: "NwB7Bi5dQF8",
    comments: [
      "I love how Britt tries to fix his hair and just gives up.",
      "Spoon is the best, every album is epic, and they just keep getting better",
      "A band that has not only gotten better w age, but that can more than deliver every time live. Spoon are ace.",
      "every once in a while in my life, I listen to Gimme Fiction, it is one of my favorite albums evah mofos.",
      "Goddamn that’s a good set.",
      "If you want rock n roll, this is just about as good as it gets.",
      "the intro to do I have to talk you into it is great",
      "The bassline on don't you evah is so awesome. Still my favorite Spoon song.",
      "This hot show, especially Pink Up, blew me away. So many mesmorizing songs.",
      "This is overwhelmingly amazing",
    ],
  },
  {
    artist: "Spoon",
    id: "0tdeWIIMHbA",
    comments: [
      "how does spoon always sound Exactly Correct",
      "I've seen spoon at least 12 times and never have i been anything less than amazed.",
      "I don't know when but one day I will surely see you guys live. Awaiting that life changing moment.",
      "legends",
      "awesome!",
    ],
  },
  {
    artist: "1975",
    id: "5kiY87XLahk",
    comments: [
      "The 1975 is the band that i want to listen when the worlds is ending.",
      "I am now cured of corona virus",
      "this was one of the most iconic shows of the decade",
      "T H E   1 9 7 5   Y O U ' R E   M Y   M E D I C I N E",
      "George is a drum beast, such an underrated drummer, he doesn't need to play 200 bpm to be so good,god.",
      "this is the prettiest thing that i ever see",
      "My boyfriend just broke up with me today and I’m just here to comfort myself. Thank you The 1975!",
      "How ironic that when Matty sings \"I'm looking through you while you're looking through your phone\" a sea of phones can be seen in the audience.",
      "God, how i'm fallin love too much with this music",
      'man, that performance of "the sound" is absolutely mental.',
    ],
  },
  {
    artist: "Police",
    id: "3RWbh9KKkdI",
    comments: [
      "I'm convinced stewart Copeland thinks his drums owe him money.",
      "God will people just start playing instruments again for the love of god.",
      "Why do we spend billions on particle accelerators when science should just study Stewart Copeland's  drumsticks LOL",
      "anyone who tries to say that Copeland isn't one of the greatest drummers ever to walk on this planet needs their head looking at",
      "Copeland in his prime was like TNT with drum sticks attached",
      "Stewart and his extreme attack , Andy's layed back chords and Stings Vocals and Bass are all absolutely Brilliant .",
      "the only concert that the band played entirely in their pajamas.",
      "What a band, what a DRUMMER....Stewart Copeland = god with a drumkit",
      "Nice to see no smartphones in the audience! :D",
      "Sting solo career was good....... but with The police he is a master with the masters stewart and Andy...",
    ],
  },
  {
    artist: "Police",
    id: "F4VjsqR5Vbc",
    comments: [
      "the hi-hat show: featuring The Police",
      "Stewart Copeland = Legend",
      "Copeland is just mesmerizing.",
      "Stewart Copeland is absolutely awesome",
      "Drummer has some of the best percussion skills going, unreal",
      "The Police: now with 40% more hi-hat...",
      "goddamn sting and that fretless bass on walking on the moon",
      "Best drummer on the planet!",
      "Walking on the moon. Damn. What a song!!",
      "One of the greatest bands ever.",
    ],
  },
  {
    artist: "Radiohead",
    id: "C9_IhE5Xk0k",
    comments: [
      "i love how radiohead is releasing all this stuff it's so cool",
      "King of Limbs is the definition of underrated...",
      "i will force my children to listen to this",
      "This is a good show because Thom has a ponytail.",
      "they play in their own league... the most important band of the last 25 years...",
      "Radiohead is an ancient treasure a moment of silence to the people that haven't heard them.",
      "The end of Pyramid song is breath taking!",
      "Thom dancing is so cool",
      "Why does Jonny's guitar sounds so low at most songs?",
      "Toms voice is totally on it through this whole thing",
    ],
  },
  {
    artist: "Radiohead",
    id: "RjQZd8p-eBM",
    comments: [
      "Back when Thom looked like a KPop star instead of homeless old man",
      "Johnny Greenwood back when he was looking older.",
      "6 years later this band released Kid A",
      "It feels so weird that the audience isn't singing along to Fake Plastic Trees",
      'The "My Iron Lung" here is literally the recording used on the album. Fantastic stuff.',
      "There's something really special about \"Blow Out",
      "They had such a different energy back in early 90's",
      "Blow Out is really an excellent set closer.",
      "Always weird seeing Phil with a wig",
      "This is the most still i have ever seen Colin during a show",
    ],
  },
  {
    artist: "Radiohead",
    id: "MuqDMOr_aLk",
    comments: [
      "one of the best radiohead shows ever",
      "I am listening in the dark with a glass of wine.",
      "Its 4 am and I stayed awake for this",
      "The National Anthem is always insanely amazing.",
      "Finally i can watch Jigsaw Falling into Place live",
      "Best version of All I Need, hands down. Transcendental !",
      "Jigsaw Falling into Place",
      "Best concert in my life!!!",
      "One of the best Radiohead eras. Jonny's hair was fire.",
      "best show ever by far",
    ],
  },
  {
    artist: "Alanis Morissette",
    id: "Y1RP0hXWgX0",
    comments: [
      "she makes it difficult for the snipers",
      "She s Walked at least 20km",
      "The bassist is the most 1999 looking man I have ever seen",
      "Alanis was the Janis Joplin of this Woodstock '99 edition",
      "Her voice is stunning. Just like it sounds on the albums.",
      "Holy shit Alanis is good live. This set is off the charts good.",
      "Alanis Morissette is a rock and roll goddess. Little pill was the soundtrack of the 90's and her and her band killed it at woodstock 99",
      "This woman's voice is incredible! She's special.",
      "She is authentic.",
      "Great Performance... Awful crowd.",
    ],
  },
  {
    artist: "Alanis Morissette",
    id: "jIRmCrHFXBw",
    comments: [
      "How many of us love this woman? She's a music legend, she's an inspiration",
      "Ladies and gentlemen THE GODDESS OF ROCK. She is so powerful!!!!!",
      "I still have the VHS in my cabinet",
      "This is so iconic!!!",
      "I Love THIS Era",
      "I can't describe what I feel with Alanis. It's so true.",
      "Amazing. When the world was just simply a better place.",
      "One of my favorite albums ever",
      "Blu Ray reissue please!",
      "Thanks Alanis! we love u",
    ],
  },
  {
    artist: "Phoenix",
    id: "STixAvSrnlc",
    comments: [
      "One of the most under appreciated bands in the history of music",
      "Phoenix should be headlining Coachella",
      "drummer is god",
      "Kids better listening this band.",
      "THIS SETLIST IS GLORIOUS!",
      "The drummer is soooo on point, perfect performance!",
      "Armistice is on a different level",
      "so freaking amazing, this band is absolutely incredible and so underrated, and the drummer is a legend for sure!.",
      "I could watch the drummer all day long........damnnnnn......",
      "That synth line is absolutely dominating this performance on J-boy.",
    ],
  },
  {
    artist: "Starsailor",
    id: "pOn3K86p--o",
    comments: [
      "Been a fan since MGS3 which feels like so long ago.... Love your music!",
      "Love it!",
      "Class!!",
      "Thank you for accompanying me from my junior years (2002) til this time.",
      "First song heard from them is Four to the floor when I was at middle school.",
      "Fabulous.",
      "Amo",
      "Man! Love it!",
      "Love this band",
    ],
  },
  {
    artist: "R.E.M.",
    id: "LuLH-Br7g0Q",
    comments: [
      "Like the country one too.....",
      "We really needs these guys to start playing and writing again.  Such a void in music now.  They are way to good to stop playing.  Vacations over...lol",
      "Amo !!!",
      "Your voice, heart, soul and eyes. WOW AGAIN AMAZING. just Julie",
      "Amooooo!!!",
      "The best i ever seen...thanks REM!",
      "most touching moment",
      "WOW, IT LOOKS LIKE HE HAS TEARS.",
      "Me too. Love them !!!?",
      "Wow love the use of the mandolin !",
    ],
  },
  {
    artist: "St. Vincent",
    id: "UHjELj8FhD8",
    comments: [
      "she is a baddas guitarrist.",
      "Annie is such a great guitarist. She has taken David Bowie's aesthetic, and built her own unique sound. It's such a privilege to listen to her work.",
      "Keep your eye's open people, she's going down in music history.",
      "Annie Clark is my queen.",
      "She's so talented...one of the master of distortion guitar...",
      "Fantastic, now she's in her Bowie stage! Somebody introduce her to Nine Inch Nails",
      "The guitar solo at the end of rattlesnake is freaking awesome!",
      "The effect on the snare at the beginning reminds me of an AT-AT shooting!",
      "One of her best performances.",
      "I love this so much. Annie is such a genius.",
    ],
  },
  {
    artist: "Courtney Barnett",
    id: "xV_zbJ8SflU",
    comments: [
      "Neil Young was right. Rock and Roll can never die. What a refreshing sound!",
      "Go Courtney!",
      "She really is a true modern rock star.",
      "all bow before the Queen",
      "I never really clicked with Hopefulessness until seeing Courtney live. Then I GOT it: it's a rock song, it's practically a Nirvana tune. Awesome talent.",
      "So happy she added the keys to her live shows for the new record, makes the songs sound much fuller.",
      "her entire band is so lovable.",
      "Im a little obsessed. Haven't heard something so classic but new since The White Stripes i'd say.",
      "god shes stupid hot the way she plays her guitar",
      "This rocker can shred a freaking guitar, wow.",
    ],
  },
  {
    artist: "Courtney Barnett",
    id: "ti8-z_ORI5U",
    comments: [
      "That is the correct hairstyle for Barcelona.",
      "I can't believe she is the only guitarist in the group.  It  is such a full sound.",
      "Courtney Barnett is my number one bucketlist concert.",
      "Yea she is a fkin bad ass, speaks truth, rips left handed guitar perfect style-",
      "Courtney is so freakin rock n roll!!!",
      "This was one of the BEST sets!",
      "I'm into C.B.",
      "Amazing artist!",
      "first time i see her playing at night lol",
      "chicks with mullets <3",
    ],
  },
  {
    artist: "Courtney Barnett",
    id: "A3D6v-u67x4",
    comments: [
      "She's pretty fricking cool. So unassuming and kick ass.",
      "She could be Paul McCartney's daughter.",
      "in this digital age she, unlike most of her contemporaries understands dynamics",
      "Damn her Sonic Youth's shirts so cool",
      "So original and great guitar tones .... love her 70s hair!",
      "fabulous but listening here the bass is inaudible",
      "Great performance !",
      "sonic youth",
      "Courtney is so Awesome!",
      "Sounds awesome despite not being able to hear the bass.",
    ],
  },
  {
    artist: "Sonic Youth",
    id: "hUcShyAarjw",
    comments: [
      "you guys are incredible and a total inspiration",
      "I wanna be kicked by kim gordon",
      "concert is AMAZING!",
      "They’re still teens who love Sonic Youth",
      "Just imagine being allowed to express yourself!",
      "Sonic Youth is playing next...",
      "Steve Shelley -so underrated",
      "Unforgettable concert!",
      "Nice!",
      "Sonic Youth Forever.",
    ],
  },
  {
    artist: "Bastille",
    id: "nHHW-owvHdI",
    comments: [
      "Woody throws a drumstick at Kyle",
      "I love Dan's bad dancing",
      "So jealous of the girl in Icarus that holds Dans hand",
      "i just wanna cry dan's voice is stunning",
      "Has to be my favorite band",
      "POMPEII never gets old",
      "Love this!",
      "That moment you name your child Daniel....",
      "oh they became my favourite band right now",
      "Weight of Living",
    ],
  },
  {
    artist: "Bastille",
    id: "uiU06Jx0B3Q",
    comments: [
      "So, a band with a great album, doesn't lipsync, and talks to the crwod of fans live, whats not to love about them.",
      "If you don't think Dan is adorable, you're wrong",
      "How can he sing and go up and down stairs at the same time. I can barely breath and go up the stairs.",
      "How does his voice  not shake when he jump?",
      "The security guy was so pissed when Dan climbed over  the pole during flaws",
      "Dan's dorky dancing gives me life",
      "his dance moves reminds me of Lorde's dance moves",
      "Bastille is the best band in the freaking world okay",
      "Look at him dancing then getting embarrassed and stopping, so adorable",
      "the dancing... haha dan is great, love the energy they all have",
    ],
  },
  {
    artist: "Sheryl Crow",
    id: "dWrrdxviU-w",
    comments: [
      "those pants..",
      "Sheryl is an excellent musician and a great charismatic singer !! A complete artist! I adore her!!",
      "Sheryl has a great voice, I love it, she's the best singer & musician, that's why I admire her!",
      "Her voice sounds great, and she's such a good musician.",
      "she's so GOOD",
      "Love Sheryl Crow. What's her drummers name. Love watching him. He's so full of energy",
      "Awesome concert.",
      "Great Concert!!",
      "OMG she is so hot!",
      "In love!!!! Lol",
    ],
  },
  {
    artist: "Eric Clapton",
    id: "fqz2AhQsRWE",
    comments: [
      "Old slow hand Eric can still play a pretty mean guitar.",
      "Clapton is still better than most guitarists with one hand tied behind his back! Best guitar player ever in my humble opinion!",
      "Does anybody recognise what a good drummer Henri Spinetti is?",
      "Love the music though!",
      "subtle and masterful, like old wine.",
      "Those back up singers are awesome!",
      "Clapton and Page the greatest!",
      "He's in such a good shape..",
      "Clapton is God'",
      "its CLAPTON! its GOD!",
    ],
  },
  {
    artist: "Chicago",
    id: "_oAoSZ2y1cw",
    comments: [
      "Is anyone as obsessed with this concert as I am? It's led me to believe that Chicago is one of the top bands of all time.",
      "Terry Kath was one of the best guitarists of all time.",
      "No pyro, no smoke machines, no big fancy light show...just a super talented band kicking ass for 90 minutes.",
      "Terry Kath - sang like Ray Charles, played like Hendrix .",
      "this is the greatest performance Ive ever seen in my life. How do such young people write such amaizing music.",
      "After watching this, I think Jimi Hendrix was right about Terry Kath!",
      "This was Terry's band, what a guitarist!!!",
      "WHAT ABOUT THE DRUMMER????? SO NATURAL AND COOL...",
      "Terrys vocals on color my world are timeless",
      "This is Chicago in their prime. So good...so damn good.",
    ],
  },
  {
    artist: "Placebo",
    id: "NF5vr0owif8",
    comments: [
      "I just realized, nobody is holding up a phone, for a change.",
      "One of the most underrated singer of all time! He sounds exactly like the studio version",
      "Brian Molko looks kind of like Uma Thurman in Pulp Fiction after the drug overdose here.",
      "They should really try and play some songs from their first two records. They're legendary.",
      "He looks like the king from Shrek with that hairdo",
      "Placebo are really incredible and sincere...Brian's manner of singing is unique.",
      "This is awesome, Placebo are like a fine wine",
      "That chick with flower headband",
      "love placebe!great music and lyrics,much better than that comercial muse!",
      "This is always my go to Placebo concert when I need a fix.",
    ],
  },
  {
    artist: "Aerosmith",
    id: "Gerf9gHEJoY",
    comments: [
      "Joe Perry , the coolest guy in rock history.",
      "the fact that they play quite a few deep tracks and not just all their hits live shows how confident these guys are in all of their music",
      "Holy cupcakes!!",
      "He must be the best LIVE SINGER in the world, his voice is perfect.",
      "Steven Tyler is without a doubt the greatest frontman in rock history.",
      "Hands in the air without cell phones... You gotta love it!",
      "Everybody talks about Joe Perry, but can we please take a moment to note how Tom Hamilton is one of the coolest bassists ever?",
      "This is what a PROFESSIONAL rock band looks like!!!!!",
      "These Boy's were on top of their game at this show!",
      "the best band of all time!!!! they have it all!!!",
    ],
  },
  {
    artist: "Aerosmith",
    id: "HSBOCnpLSV8",
    comments: [
      "Tyler and Perry coked to the gills.",
      "Gotta be one of the ugliest stage designs I have ever seen.",
      "I was so high I thought it sounded great",
      "Yikes.",
      "The first Monsters Of Rock!",
      "AC/DC smashed this event",
      "Nice hearing Reefer Headed Woman...kind of rare!  Great tune.",
      "Mr Perry playing Stratocasters...yea Joe!",
      "Ahhh, days on the green, thank you Bill Graham.",
      "I hope the guy who oked this stage got fired.",
    ],
  },
  {
    artist: "Iggy Pop",
    id: "HAgaCs5hruc",
    comments: [
      "Iggy always brought along the best musicians. Pure skill everywhere. So enjoyable.",
      "The Grandfather of punk and still going strong.",
      "ITS GAVIN HARRISON ON DRUMS",
      "Iggy the voice!",
      "Gavin Harrison plays the drums!!!",
      "its funny how most of the live stuff is Stooges,you never forget your first love.",
      "Band NAILED this show !",
      "his voice sounds amazing here!!!",
      "the igster is always good",
      "iggerizzed!!!!",
    ],
  },
  {
    artist: "Clash",
    id: "CLKl6FIBH0U",
    comments: [
      "the drugs really kicked in at during jimmy jazz, and i'm referring to myself and not joe",
      "Mick Jones  unsung hero of the clash",
      "Bruce Springsteen wishes he was Joe Strummer",
      "Best Punk Band...In my opinion. Joe is just great.",
      "only band that matters",
      "Joe Strummer...maybe the best frontman I've seen.  And there are so many great ones.",
      "Jones is brilliant on Spanish Bombs",
      "This is a 5 star Clash concert",
      "Complete Control what a song!!",
      "A fantastic performance by a great band at the peak of their powers.",
    ],
  },
  {
    artist: "Ramones",
    id: "Sp3zaeOyL7Q",
    comments: [
      "And every kid in that crowd went home and started a band.....",
      "This is absolutely one of the best recorded live concerts ever.",
      "Ramones didn't have a style, they were the style",
      "how tf does joey breathe throughout without a break, what a king omg",
      "Johnny is way underrated, even among Ramones fans. Arguably the best rhythm guitarist of all time.",
      "This is what it feels like to go through a blender.",
      "Mind blowing, these guys didn't give a shit and built their own universe, epic.",
      "Best live album of all times from any artists known to mankind!!!!!!!",
      "This is a treasure.",
      "One of the most powerful live performances  ever...",
    ],
  },
  {
    artist: "Duran Duran",
    id: "T4dKTblXrF4",
    comments: [
      "Most bands have a lead guitarist ... Duran Duran had a lead Bassist!",
      "This is GOLDEN",
      "John Taylor on top of his game! Dig that bassline...",
      "right out of the gate, Duran Duran's bassist is phenomenal...I never realized! Wow!",
      "They single handedly kept the white pants industry alive!",
      "Outstanding! The Taylor's are all full throttle.",
      "That bass is legit",
      "I've always loved the bass on New Religion; absolutely funky and fabulous!",
      "John Taylor and that bass.",
      "This band has a lot of future potential.",
    ],
  },
  {
    artist: "Fall Out Boy",
    id: "-3LfOi2EfHE",
    comments: [
      "this audience is why MCR wrote a song about teenagers",
      "I can't believe people don't know who Fall Out Boy is.",
      "Andy has a nice shirt there.",
      "fall out boy will be the death of me.",
      "I AM DISAPPOINTED IN THE CROWD",
      "I love how Patrick and Pete just skip around! It is so dang cute!",
      "Patrick is just the sweetest thing",
      "Joe's hair is bigger than my future",
      "Pete is a spooky scary skeleton",
      "it was so cute when Patrick skipped across the stage omg",
    ],
  },
  {
    artist: "Grouplove",
    id: "ky3uVoQeK8U",
    comments: [
      "Absolutely love Hannah's energy.",
      "One of the best live bands you'll hear these days. Pure energy",
      "There drummer is so sick",
      "love how much heart they put into the performance.",
      "There drummer looks like an older Nat Wolff",
      "xD I love the drummers faces",
      "everyone with there face in their phone doesnt deserve to be there.",
      "Huge crush on Hannah",
      "I simply love this group!!",
      "Just wow amazing haha, so much energy and emotion put into their work.",
    ],
  },
];

export const blue = [
  {
    artist: "Sigur Rós",
    id: "n-BjxCpmxmo",
    comments: [
      "This concert is like a drug for me.",
      "I like to divide musical groups into two basic categories: A. Sigur Ros B. The other bands",
      "This concert has repaired my DNA.",
      "Music and art will save our souls.",
      "I'm pretty sure Staralfur is the best song ever written",
      "life is too short",
      "Just imagine if they played Varúð  with orchestra... That must be magical",
      "Every time I listen to À... I can't breathe. It's so beautiful!",
      "This is just magnificent: I have no words.",
      "Just incredible. I can't find the words to adequately express how I feel.",
    ],
  },
  {
    artist: "Rudimental",
    id: "5hw77PAxlUk",
    comments: [
      "Anne Marie the best I love Anne Marie",
      "I love anne-marie and sinead harnett",
      "mucho flow!!!!!",
      "Best Rudimental performance",
      "feel the love",
      "Amazing! Innovative and epic.Great job!",
      "...as always, one of the best vibes are made in UK!!",
      "They are awesome",
      "that little dance",
      "right here",
    ],
  },
  {
    artist: "Rudimental",
    id: "6m7XWVIYqTs",
    comments: [
      "Sounds engineer needed",
      "Rudimental <3",
      "LIKE FOR MORE HOZIEER!!!  BY THE WAY IM BUZZ LIGHTHEAR...!!!",
      "Will hearddddd",
      "Will Heard!! <3",
      "Absolute GODS! Love them all :)",
      "So amazing",
      "What a classic!",
      "realy realy gooood song",
      "i love rudimental ❤",
    ],
  },
  {
    artist: "Rudimental",
    id: "6XjATefHBjI",
    comments: [
      "That drummer rules!!!",
      "Ella Eyre got the best vocals from the vocalists, imo, she sings so heart-warming yet spine-shiver-crawlingly! <3 and makes it look so easy",
      "the trumpet player is awesome",
      "The drummer and the bloke on trumpet are both fire!",
      "Why is Ella not their lead singer......,i just don't gettit :-(",
      "the song name is: SOLO",
      "Fantástico!",
      "I love Ella",
      "I LOVE THEM!!! YOU ARE AMAZING GUYS! <3",
      "Loveloveloveeeeeeeeeee this",
    ],
  },
  {
    artist: "AIR",
    id: "ZP9SvddHdO0",
    comments: [
      "This is the best concert in my life so far.",
      "What a band. They are amazing. When someone tells me that electronic music is not good, I tell them to listen to AIR.",
      "Amazing concert. So pure, so simple.",
      "I am an air fan since 1998, one of my favorite bands ever.",
      "There's nothing like AIR.",
      'Music is a language in what it speaks to us, we "understand" something even if we don\'t know what. Thanks Air to give us these beautiful tones ;)',
      "Sounding that good is supernatural. There are exceptional sound guys working behind the band.",
      "Absolut fantastic! The soul of old and new synths in perfect combination.",
      "This is magic, it's magic...music is the only language all people do understand. La Femme d'Argent is wonderful",
      'what a great and potent version of "how does it make you feel?',
    ],
  },
  {
    artist: "AIR",
    id: "3GALJl6Y16w",
    comments: [
      "Air fans are type of people that i would be friends with",
      "We need a new album ASAP !!!",
      "Beautiful concert. Unfortunately the architect's name is not Niedemeyer, but Niemeyer. Cheers!",
      "If anyone can work those old vintage analogue's it's these boys. Great stuff guys.",
      "I'd forgotten just how much I love Air.....what a class act they are!",
      "Amazing!!",
      "The opening of Cherry Blossom Girl just made me almost cry!! The lights!!",
      "whoever did the lighting and the building it was perfect. the inside resembles a magnetic field. the reciprocating hyperbaloid",
      "The angels went back down to earth from space.",
      "It is such an honor...to be a fan of this group and their music. Thank you, AIR.",
    ],
  },
  {
    artist: "AIR",
    id: "-XSSQGfIV8A",
    comments: [
      "Absolutely fantastic!",
      "One of my favorites bands of all time!",
      "Magnificent !",
      "Great concert.",
      "An absolutely perfect set and  performance.",
      "GREAT song",
      "Stunning",
      "cool",
      "Fabulous.",
      "nothing but hot air",
    ],
  },
  {
    artist: "Chet Faker",
    id: "8PIr3SToDVM",
    comments: [
      "Chet's got some nice dance moves right there!",
      "they didnt give a damn still on their phones lol, i can say chet faker is one of my favorite musicians such an amazing talent",
      "Yes! His voice is heavenly",
      "i swear the rest of the band just teleports on and off...",
      "so great. super cool seeing him with an audience this large, he rocks it",
      "When cigarettes and chocolate drops...",
      "thousand likes to his performance. love it love it.",
      "And Talk is cheap",
      "bravo bravooooooo",
      "why are none of my favorite chet faker songs on spotify wtf",
    ],
  },
  {
    artist: "Chet Faker",
    id: "veCnQve0rqc",
    comments: [
      "This is good but I thought he was much funnier in The Hangover.",
      "this guy has serious talent. multitasking all that live is real.",
      "I really like this guy. Glad to have found some newer artists with flavour. <3",
      "When you play a song for the first time and it's 1998... art in a few minutes",
      "DAMN ! NO DIGGITY Killed",
      "he's so hot it makes me cry",
      "legit chill...love his soul style",
      "I give him props!! LIVE AUDIO AND VOCALS! This guy is talented!!!",
      "This guy is so fk'ng talented",
      "This is just perfection",
    ],
  },
  {
    artist: "Anderson .Paak",
    id: "pCDJv4WQ_bc",
    comments: [
      "Mark my words, Anderson .Paak will be a legend.",
      "He will go down in history. He doesn't just appeal to R&B fans, or hip-hop fans... he appeals to fans of ANY MUSIC.",
      "Wheres that dope keyboard player of his? He is missed here.",
      "Prince is looking down on this dude smiling forreal",
      "This is that 70s funk soul shit, love it.",
      "I need to hear .Paak and 3000.",
      "YES LAWD",
      "Want .Paak to become a legend",
      "That one dude screaming the lyrics is dedicated.",
      "the kendrick lamar of soul",
    ],
  },
  {
    artist: "Anderson .Paak",
    id: "tLYwPSz-MJ4",
    comments: [
      "Anderson is a genius of our time and isn't receiving the attention he deserves. No one compares with him and wont for a long time",
      "He is so unbelievably talent overall you can’t help but just admire his performances... go watch his tiny desk",
      "The entire set, band and background singers included, was incredible",
      "One white boy in the back say he know how to two-step",
      "RIP KOBE RIP MAC",
      "Love the Kobe tribute #8",
      "How is this crowd so dead... saw him live and he’s one of the best shows I’ve ever seen",
      "He plays drums?",
      "Yessirrr",
      "Who are the girls in the back",
    ],
  },
  {
    artist: "Anne-Marie",
    id: "TDB578_bNJE",
    comments: [
      "Anne Marie fans❤❤",
      "I love the way she screams. It doesn't hurt and it fits, enough pitch, enough thinness. Waah, her voice is so unique.",
      "She's the happiest singer on the stage ever, i love her positive vibe",
      "She is born to be a performer. No back up dancers nor dance steps needed, just unbreakable connection with audience! ❤ you Anne Marie!",
      "She's a fan of her own. And that's a beautiful sight.",
      "She's pure talent, she slays either live or in recording.",
      "Flawless She is so talented!!! Love her and her voice",
      "Anne Marie is one of the few artists who can really put a show on. Like literally",
      "this queen did not even need backup dancers",
      "This is one of the most genuine concert i've ever watched! She's a gem!",
    ],
  },
  {
    artist: "Ed Sheeran",
    id: "223eI1x6PsQ",
    comments: [
      "Talented beyond words, who doesn't he touch A great artist",
      "He's rocking the crowd with just his voice and his solo guitar.. He is truly a legend legend Singer.....",
      "I love how ed sheeran only uses his looper instead of having a band with him. Hes just truly amazing and such a humble performer.",
      "Finally someone who sounds just as good live as recorded",
      "Can't get enough of Ed,he's so talented. He reminds me of my son whose a musician too.",
      "Just love Ed Sheeran Love all his music so talented",
      "Just have to love this Guy, such a beautiful soul in an imperfect reality...",
      "That medley was everything! It's so nostalgic to hear him sing Drunk.",
      "I really hope he is enjoying his break right now, he deserves it",
      "Awe, my favorite artist.",
    ],
  },
  {
    artist: "Ed Sheeran",
    id: "05272IrStv4",
    comments: [
      "This is talent guys!",
      "He doesn’t need need a band, he doesn’t need to dance, he doesn’t need to do anything else to be a perfect artist.",
      "He’s perfect like this! Doing everything with just a guitar. This incredible!",
      "I love Ed Sheeran!!",
      "This performance is so smooth. I can't believe this is all live, nothing is pre recorded, he and himself as a one man band.",
      "Bloodstream is so underrated",
      "this guy is a one-man band all he need is his guitar and his loop pad",
      "I listen to him every day! I love so much!❤❤",
      "Someone proposed during the song <Perfect>",
      "Who else is lovin that older woman in the front, bobbin her head to the beat? Awesome!",
    ],
  },
  {
    artist: "Ed Sheeran",
    id: "lR3vIjAZDnM",
    comments: [
      "Does anyone else not find it crazy that this whole concert is him, his guitar, and a loop pedal?",
      "That shows that he is one of the greatest musicians of our time.",
      "ED Sheeran is precious and needs to be protected at all costs",
      "Ed is my daughter's hero, she wants to be just like him when she grows up. I see why.",
      "i watched the whole video and guess what? i didnt waste a single second of life",
      "HOLY JESUS ED IS AWESOMEEEEEEEEEEEEEEEEE!!!",
      "He's a one man band, and he is a genius for sure.",
      "This is like the only artist that sounds the same as live and in the recorded songs.",
      "i honestly believe he is one of the few artists who sound even better live",
      "Almost 2 hours,  singing and playing by himself.  Absolutely legend.",
    ],
  },
  {
    artist: "Tracy Chapman",
    id: "kUXahDmsVdU",
    comments: [
      "She is my angel baby. I wish i could hug her for 10 mins straight.",
      "This is one of those songs that seems like has existed from all eternity",
      "Such a voice comes once in a century. So unique and touchy.",
      "First heard this talented lady in concert opening for Bob Dylan about 30 years ago. I was blown away. Still am. Timeless.",
      "Thank you, Tracy, for sharing your artistic gifts. Your voice brings me comfort and smiles.",
      "The best acoustic solo performance in history of popular music.",
      "Tracy is the best",
      "So pure and clean music.  A  guitar and her voice is all that was needed to make great music.",
      "I love Tracy with my whole life!! Her songs have been a source of inspiration to me..",
      "Very Real . Thank you Tracy .",
    ],
  },
  {
    artist: "Simon & Garfunkel",
    id: "Bxryb3xN-Lo",
    comments: [
      "So sad that there was no connection to each other on the concert. They made beautiful songs.",
      "And who is so not interested came with a solo guitar in The Sound of Silence?",
      "ART VOICE is so Cool as ICE..",
      "These song has only four guitar key...Dm, C, Bb and  F",
      "Thank you, Simon. Thank you, Garfunkel. Its An everlasting Joy.",
      "Bridge over troubled water is my all time favourite since I was 9",
      "Beautifully done. Arts voice is magical..",
      "Yester years were great when music was really music. I just dont get tired listening to S&G especially on a long drive.",
      "I got lots of memories with their songs, paul simon is the reason why i learned to play guitar. Quality Music",
      "Quiet just listen !",
    ],
  },
  {
    artist: "Marcus Miller",
    id: "J2VL0uqZP18",
    comments: [
      "One of the hardest jazz and base players of all time he is I'm telling you. Big up Marcus miller always I'm a huge fan",
      "Marvellous",
      "Thank you big legend",
      "Thank you Marcus and your friends , Nice !",
      "Finally get to see Marcus play the fretless live. Such a sweet feeling & sound.",
      "what a gentleman",
      "Marcus singing on the fretless, those lyric moments we don‘t get that often in the pop-slap universe.",
      "YEAH!  MM always come wit the best live intros! Yessssssssssssssss!",
      "man, the piano samples on those Nords have gotten quite good, I must say...",
      "Best performance in recent years!",
    ],
  },
  {
    artist: "Lumineers",
    id: "353lHGbvu8o",
    comments: [
      "Don't understand how Woody Harrelson has time to play the drums for these guys in between his acting gigs.",
      "If The Lumineers dont perform on my funeral im not going.",
      "It's better to feel pain than nothing at all",
      "there are a few things in life that a human being just should not do. disliking the lumineers is one of those things.",
      "Ive never heard a more genuine sounding band.  These guys need to go on tour with the head and the heart.",
      'this isn\'t music. This is far beyond that. Anyone can make songs but not many can make you "feel it". I feel it.',
      "Neyla deserves more attention than she actually receives.",
      "the drummer always looks like he's having the time of his life. Great band altogether, i hope they will be around for many years.",
      "The Music is just wow !",
      "Stubborn Love is literally life.",
    ],
  },
  {
    artist: "Lumineers",
    id: "Ud6nR6QKNmA",
    comments: [
      "Flapper Girl is so underated, such a great song",
      "The woman playing the cello, she has the most beautiful smile, the music is pretty good too :P",
      "some music is better live and recorded like this than the studio - very tight band",
      "It's not music, it's magic!",
      "And when it came to love, we were not good enough for it",
      "I wanted to listen to their music without  crying. Impossible.",
      "I am madly in love with The Lumineers!",
      "My God that woman is gorgeous! To me there is nothing hotter than a girl who plays an instrument!",
      "This Band is so amazing. Can´t wait for the new Album!",
      "She is beautiful omg",
    ],
  },
  {
    artist: "Snow Patrol",
    id: "X80i7-Dq2yg",
    comments: [
      "If you want an example of how to mix live sound - this is it - sounds amazing",
      "Incredible. The audio is amazing. The Engineers need a massive credit",
      "Gary seems to get a genuine kick out of hearing the audience sing his music. The huge smile on his face is adorable.",
      "Gary's light hearted fun attitude along with his relaxed confidence comes thru in a sincere charming way. You can tell he loves what he does.",
      "The performance of “Heal Me” is stunning, epic!!!",
      "Best band in the world!!??",
      "Amazing acoustic set. Best I have ever heard.",
      "WOW....JUST WOW!!! A night I’ll never forget.",
      "Wow. They’re such a talented band.",
      "That version of run awesome ♥️♥️♥️♥️",
    ],
  },
  {
    artist: "Prince",
    id: "uAYQUbh8HHA",
    comments: [
      "People who never saw Prince in concert have no idea what they missed",
      "Everyone in this band was a damn good musician.",
      "always sang  never lip sync and always sound like the record",
      "He was 24 years old when this was recorded.  Amazing.",
      "Now THAT was a concert! There are no artists like this today.",
      "Do me baby, sexiest song ever written",
      "The stage was his home, his church.",
      "He is not a Prince, he is KING.",
      "Jimi Hendrix....Here's the Prince we told you about.",
      "He was only around 23 years old.",
    ],
  },
  {
    artist: "Sam Smith",
    id: "3k-cUy9F1Vc",
    comments: [
      "Finally he is comfortable with himself and I'm living for it............... THAT OUTFIT IS LIFE <3",
      "Someone so confident, so in love with their voice, their body, their sexuality and ya'll cant seem to handle how amazing this person is.",
      "he seems so happy, he's litterally glowing, i'm so mesmerized",
      "I love that he’s dancing now. So proud of him",
      "He is being he's true self and he's glowing",
      "Live Sam. People just need to stop with their negativity, no one cares. Spread positivity!",
      "They are AMAZING!! AND THEY YES IS THEIR PRONOUN. NON BINARY FINERY.",
      "This is absolutely perfection in all sense!!!",
      "He has a perfect eyeliner and his simply majestic voice",
      "LOVE the diversity in his backup dancers! YES representation!",
    ],
  },
  {
    artist: "Michael Jackson",
    id: "Hxgo-Qu-ZZE",
    comments: [
      "The most talented pop music icon that ever existed!",
      "To Everyone here: You have a great taste in Music!",
      "The best Singer of the world and I believe he isn't death only king of Pop heeeeeeeeeeeeee!!!!!!",
      "No cameras , no smartphones , No Internet ,people were 100% connected to Michael",
      "He donate the money off all childreen Houses in Romania ...after the concert what a kind man...beautifull soul",
      "B E S T   A R T I S T   O F   A L L   T I M E",
      "Michael Jackson is the king of pop that nobody will change him being dead",
      "Not only Michael is gifted, he cared a lot about his fans.",
      "no one recording , just enjoying Michael Jackson’s talent !!!",
      "This is the best concert ever ... There will never be another Michael Jackson...",
    ],
  },
  {
    artist: "Travis Scott",
    id: "iaFKqyP_V88",
    comments: [
      "travis has the best concerts dont @me",
      "I almost died. Best time of my life",
      "most beautiful thing you’ll ever hear",
      "The kid who went on stage is lame asf",
      "Travis is a humble man",
      "5% tint dope asf",
      "why Travis is goated",
      "Guy with the phone missed his chance to have a moment",
      "Astroworld coming",
      "“Out Of This World”",
    ],
  },
  {
    artist: "Branford Marsalis",
    id: "sQQ0EvJZvFg",
    comments: [
      "I can't stop dancing!!! Great quartet and great music!!",
      "That bassist was really diggin it",
      "Jazz is In his Gene!! smooth!!",
      "Calderazzo really kicks ass!!!",
      "Tain and Revis ain't bad either!!!",
      "I love Brantford. His style is Grown and Sexy and undoubtedly amazing!!!",
      "Beautiful!!",
      "monster master class!",
      "Performance.",
      "Joey plays hard!",
    ],
  },
  {
    artist: "UNDERWORLD",
    id: "RAUbRjx6ntw",
    comments: [
      "The best Underworld concert I've ever been to.",
      "nice music, nice video.",
      "Top artists! Thanks!",
      "as always the best !",
      "Wow avesome. Young boys:))",
      "u are simply the best!",
      "\\m/  !!!!!!!!!!!! Excelent !!!",
      "big big like!",
      "Looveeeeeeeeeeeee",
      "1st track is very cool! As old favorite Underworld!!!!",
    ],
  },
  {
    artist: "Al McKay's Earth Wind & Fire Experience",
    id: "O3EVsT08Khg",
    comments: [
      "You got the best of my love oh oh oh......... Mr. Al Makay",
      "The real Al Mc Kay",
      "Genios...",
      "Wow, thank you....that was awesome....Thank you Al for keeping music alive...  :)",
      "love it",
      "Basse Mr. James Manning, hey!",
      "WOW  Wonderfull band",
      "Awesome",
      "Great horns.",
      "You cannot beat Maurice’s silky tenor voice",
    ],
  },
  {
    artist: "BTS",
    id: "b9cG4DzpL_c",
    comments: [
      "Lets face it Grammys can't afford a BTS stage",
      "They literally turned an Award Show into a CONCERT.",
      "Sorry Grammys but this was better than your whole show",
      "This performance proved that BTS didn't forget from where they started",
      "I can't say anything except... \"I feel so proud! I'm about to cry.",
      "This shows how the Grammys can't afford a stage for BTS. It's like trying to put a chandelier inside a phone booth xD",
      "So Grammys were scared of the quality that BTS serves",
      "That water dance is one of Jungkook's MOST ICONIC dances ever",
      "Ok. But This whole performance will forever be ICONIC.",
      "I understand why Grammy is scared to invite BTS for a whole performance HAHAHAHA",
    ],
  },
  {
    artist: "Disclosure",
    id: "Hc7igEnZsIs",
    comments: [
      "so soulful",
      "What a beautiful voice Sinead Harnett!!",
      "Awesome set boys, love you",
      "Tenderly always gets me moving",
      "This is soooo good. How have i only just seen it!",
      "Freakin love this group!!!!!!",
      "Still love this so much!",
      "IN LOVE WITH THIS",
      "omg",
      "Wauw this is awesome!!",
    ],
  },
  {
    artist: "Disclosure",
    id: "0dCi0f8esIk",
    comments: [
      "They deserve more than just a 30 minute set",
      "I LOVE how they play live instruments, and perform vocals. Awesome.",
      "I'm getting kinda obsessed with their music, they're so so so good!",
      "the audience seems to be high",
      "Music for people who weren't alive for the 90s",
      "these guys seem to be so young.....how can they know so much about music??!",
      "no sleeping during disclosure!",
      "These guys are the baddest on the planet, no one can touch their music.",
      'love how people lose their shit when they hear "when the fire stars to burn',
      "Bless these boys.",
    ],
  },
  {
    artist: "Explosions In The Sky",
    id: "DNMhiMtNq2g",
    comments: [
      "Your hand in mine-the most beautiful creation ever made in post rock.",
      "After watching this I realize that the earth is not a cold dead place.",
      "Instrumental songs that express more than any lyrics",
      "With tired eyes, tired minds, tired souls, we slept",
      "The ending is one of my favorite things they do for their shows. From absolute chaos to silence. It's perfect.",
      "GUYS, THAT ENDING.",
      "Although wonderful, especially on headphones, you really have to see them live.",
      "One of the best bands I've ever seen.",
      "Oh, my favorite. Simply the best",
      "...................sounds like the holy water of music to me.",
    ],
  },
  {
    artist: "Explosions In The Sky",
    id: "zDtW-WdYj-E",
    comments: [
      "lol, that crowd didn't even know the lyrics... oh wait",
      "are they playing in front of wolves?",
      "Your Hand In Mine has got to be one of the most beautiful arrangements ever written",
      "my eyes tear up. Sufism is all about soul, this has soul",
      "Raaah the sound is too much compressed, we can't hear the width of the reveeeerbs :P",
      "its always great to see bands that just really love to play live lol",
      "They always nail Disintegration Anxiety",
      "Catastrophe and the cure .... such a masterpiece !",
      "The Birth and Death of the Day is an absolute killer.  The intro is the burning sun coming up over the horizon.  So good!",
      "Best concert I've ever been to",
    ],
  },
  {
    artist: "Explosions In The Sky",
    id: "pl8w74mH1Nw",
    comments: [
      'Dude, this "The Moon Is Down" performance is simply SUPERB!',
      "Such a respectful audience. Would love to see them love",
      "What a passion, what a performance! A-mazing with a capital A.",
      "awesome band!",
      "Wow amazing setlist",
      "Nice audience, no wolf howling during the songs and in the breaks. Thumbs up!",
      "EITS ROCK! Superb guys thanks!",
      "explosions in the sky a toda hora !",
      "Your Hand In Mine ♡",
      "One of my favorite!",
    ],
  },
  {
    artist: "Mogwai",
    id: "T2aFPe7mrhg",
    comments: [
      "Funny all the people recording the show on their phones. Could have just enjoyed it, and watched a high quality recording on youtube.",
      "One of the greatest live bands I've ever seem. So many layers. Great quality here too.",
      "I have loved this band for 20 years.  I can't get enough of them.",
      "Nailed it this band is legendary.",
      "I feel like people went deaf after this show.",
      "Best version of \"I'm Jim morrison i'm dead\" ever",
      "NOOOT LOOOUUD ENOOOUUGH",
      "weird. never get tired of listening for 10 years,",
      "Mogwai Fear Satan",
      "Genial :)",
    ],
  },
  {
    artist: "Tommy Emmanuel",
    id: "ulTpIP46wFA",
    comments: [
      "One of His best concerts and I've seen",
      "Totally random but Tommy's hair is actually amazing, especially for 63.",
      "Tommy is like a good wine, hée goes better and better with time, its Incredible",
      "Phil's song is magical...",
      "Tommy has been playing almost 6 decades....he started at 4 years old in 1959.....",
      "Living legend , guitar god",
      "As good as it's ever going to get",
      "So much talent in one person! Love, love, LOVE him!!",
      "Is there anything he cant play on the guitar?",
      "Great show!!!",
    ],
  },
  {
    artist: "Joshua Redman Quartet",
    id: "E-Nc_m58TYc",
    comments: [
      "my God... McBride swings so damn hard it doesn't matter who is soloing over that bass they will be forced to swing",
      "Art Blakey trying to eat Christian Mcb's necklace",
      "Hahaha, nothing like seeing Blade and Mehldau in suits that are way too big",
      "Been listening to music for 60 years, this is the best concert I've ever heard in any genre. Astonishing.",
      "jazz can still swing!!!",
      "brilliant, swinging music.  great young guys of  the future.",
      "Wow!!!!",
      "Second tune would later be titled Rejoice!",
      "mr Brad Mehldau on piano",
      "Whooaw !",
    ],
  },
  {
    artist: "Joshua Redman Quartet",
    id: "SVNKQtPvv00",
    comments: [
      "We need a Tiny Desk Concert with these guys!",
      "Brian Blade is so subtle and sensible with his playing.. it's like hearing the love child of DeJohnette and Elvin Jones",
      "This is great!",
      "This is great. Redman is on another planet.",
      "This was absolutely wonderful. Incredible musicians, thank you for the performance.",
      "I truly believe that this quartet is right up there with the John Coltrane Quartet.",
      "Amazing set",
      "This is so perfect! Awesome concert! Awesome musicians!",
      "HEAVEN MUST BE LIKE THIS!",
      "INCREDIBLE SYNERGY!!!!!!!!!",
    ],
  },
  {
    artist: "FKJ",
    id: "ftLxvw_eFN0",
    comments: [
      "why is nobody naked",
      "This is what live DJ performances should be like!",
      "This guy is really amazing!",
      "Not only does he make incredible music, but his performances are great too.",
      "FKJ is insanely talented!",
      "To be honest, this is the best mixtape i've ever heard",
      "Never get tired of it!!",
      "FKJ is always on point man he never disappoints.",
      "FKJ improvising again like a boss, truly a talented guy.",
      "dude's a genius.",
    ],
  },
  {
    artist: "Aphex Twin",
    id: "5yQRp4j2RQM",
    comments: [
      "Is good to know Richard is visiting the earth nowadays",
      "Half-Life 3 confirmed.",
      "STONE IN FOCUS",
      "Everybody is on drugs at this concert.",
      "so many drugs were taken",
      "Rich and his wife bring a 909, seq and some synths and modular up along with the set! SO DOPE!",
      "that noise you hear while the Stalker is taking you to the Zone",
      "Last time I was this early, the stretch white limo hadn't even hit the car yet.",
      "He deserves Nobel prize for innovation in music and effects",
      "This is the proper rave sound. The actual future to all those sounds we grew up on. Great set.",
    ],
  },
  {
    artist: "Aphex Twin",
    id: "961uG4Ixg_Y",
    comments: [
      "richard that was very good",
      "bruh lets all just appreciate how well this video is put together",
      "Nice to see the kids getting down to some dad music",
      "7\\",
      "girl with the Aphex mask is extremely fashion forward",
      "INSANE",
      "this man is one of the best creatives, artists, people in the world and nobody will convince me otherwise.",
      "Best, most influential electronic artist of all time. Thank you so much.",
      "that melody will blow my mind forever",
      "You've got so many machines, Richard.",
    ],
  },
  {
    artist: "Chvrches",
    id: "1L9iUhiOXbE",
    comments: [
      "Finally!",
      "This is the first time I've heard chvrches and I'm impressed.",
      "That was one of the sickest intros I've ever seen....",
      "Shes gotten better at performing, she used to be real shy and quiet while singing.",
      "Why is Tether so underrated",
      "They should play Strong Hand in their playlist.",
      "Such a great setup!",
      "Best KISS show I've ever watched!",
      "love the face paint!",
      "I'm in love with this performance",
    ],
  },
  {
    artist: "Belle and Sebastian",
    id: "r2Y-H0v2pms",
    comments: [
      "I love Belle and Sebastian ❤",
      "stu looks like is having the time of his life",
    ],
  },
  {
    artist: "Zedd",
    id: "oVwEiNdpKeE",
    comments: [
      "Zedd is brilliant. So happy this guy exists.",
      "best zedd track of all time",
      "This is one of the sickest intros out there",
      "i love this setlist!",
      "when the molly hits soooo good",
      "god level intro !!!!!!",
      "His best set ever... Amazing and full of masterpieces",
      "That intro gives me goosebumps :D",
      "EPIC!!!",
      "Zedd my mannn",
    ],
  },
  {
    artist: "Zedd",
    id: "t5-PcziC7B0",
    comments: [
      "ZEDD did completely amazing!",
      "I feel this man",
      "He's the only person who got the crowd dancing",
      "The first song always reminds me of Avicii",
      "He is the most energetic DJ I've ever seen",
      "I love how happy he is. Seeing him happy makes me happy",
      "I find it extremely cute that he sings along",
      "This crowd dont deserve him",
      "it's so rare that zedd gets to perform but I love it anyway",
      "Worst crowd ever they don't deserve zedd",
    ],
  },
  {
    artist: "Khalid",
    id: "KdGQu7JRcXw",
    comments: [
      "The only singer who does cardio while singing.",
      "I rarely like every song from an album.",
      "The opening sounds like the opening to a church service haha it’s awesome",
      "His band is incredible and they really give that energy he needs to be comfortable in transpositions and octave changes.",
      "i thought he was better live",
      "I'm in love with Khalid's voice <3 <3 <3",
      "He just.... He's so good, man.",
      "This kid is a great talent,I hope he goes far",
      "I love his Vince costume",
      "dead crowd",
    ],
  },
  {
    artist: "James Brown",
    id: "m-Oq54jFAAs",
    comments: [
      "When it comes to singing, dancing and entertaining he is the real King.",
      "James Brown is a national treasure.",
      "James Brown is like a wild man on stage - all that energy, singing, and dancing! Excellent performance!",
      "the great James Brown, The King Of Soul.",
      "the best forever James brown",
      "See how the band tightened up as James hit the stage!",
      "Does somebody knows who are the two bassists playing ?",
      "JAMES BROWN--GREATEST PERFORMER THAT EVER LIVED!",
      "This is one of the rare times we get to see the great Jimmy Nolan on guitar.  Funk guitar icon !",
    ],
  },
  {
    artist: "James Brown",
    id: "QcwhS3VgHpI",
    comments: [
      "All you idiots criticizing his performance. At 66 he was STILL better than anyone performing today.",
      "Two Bass players?  If that's what it takes to back up the GFOS. So be it.",
      "If James Brown was never born there'd be no such word as funky",
      "The majority of the drunk idiots of the audience didn't deserve such a show.",
      "Dude had a body guard walk on stage with him!  PIMP!",
      "What an incredible amount of work it must have taken to arrange, choreograph, stage, and rehearse a show like that.",
      "wow no cellphones in the air",
      "THE KING OF FUNK MR. JAMES BROWN",
      "James Brown he is a legend",
      "now this is my kind of music, live band! you can't get no better than this!",
    ],
  },
  {
    artist: "Sarah McLachlan",
    id: "Yr0vJIs4-pk",
    comments: [
      "She's so talented :)",
      "Uniquely Amazing!    She was born to sing.",
      "Thank you Sarah for sharing your gift and spirit.",
      "one of my favorite singer with a gifted voice!",
      "What a treasure.",
      "I will listen to her do Possession any way she wants to do it.  What a talent.",
      "amazing!",
    ],
  },
  {
    artist: "Sarah McLachlan",
    id: "-Afr_MOSAQg",
    comments: [
      "Love you Sarah!",
      "So sweet that she played I Love You for one of her fans.  Sarah is such a beautiful soul!",
      "What Talent!",
      "Her voice never changes. .voice of angel and in the arms of an angel .",
      "Her voice touches & moves my spirit, I always get lost in it",
      "An amazing voice I will never get tired of hearing",
      "So beauiful, so relatable, emotionally... so raw. Touches my soul",
      "LOVE THIS artist!!",
      "Once in a lifetime artist folks!!!",
      "She's utterly brilliant. I love her so much",
    ],
  },
  {
    artist: "James Blake",
    id: "o2BVk5tWciI",
    comments: [
      "the devil asks James to marry him",
      "Much respect to James Blake.",
      'Shoutout to the person who screamed,"MARRY ME!',
      "The first 7 minutes are incredible..................................................",
      'To the Last" was performed absolutely flawlessly!',
      "The lights were spot on, hardly ever see that",
      "I really want to sing like him",
      "Love the first 7 minutes, good way to start a show.",
      "jesus christ this is amazing",
      "Best haircut's Ever!!!",
    ],
  },
  {
    artist: "James Blake",
    id: "j4qfT2dxU6E",
    comments: [
      "It's difficult for me to comprehend how much of an underrated musician James Blake is. He's an incredible talent.",
      'hahah the crowd wows got looped with his vocals on "I never learnt to share',
      "Might be the best concert I've ever seen",
      "i like these beats. its like the prefect mix of hip-hop bass lines and techno.",
      "I think, James Blake is one of the best musicians of our time",
      "Every time I listen to James Blake I get emotional, his music evokes such an uncontrollable response from me.",
      "Aww. Aww. Aww. Omlette, Omlette havin' it here.\"  - that's the starting lyrics for you.",
      "all i have to say is this is profoundly good",
      "what a brilliant performance and brilliant song! love it so much",
      "The opening song tho.",
    ],
  },
  {
    artist: "Bon Iver",
    id: "YJNi7aRwUzU",
    comments: [
      "So much credit to whoever mixed the audio. They did an incredible job",
      "The drummer looks like Socrates",
      "I feel like attending a Bon Iver concert would be a spiritual experience",
      "This DEFINITELY needs to be set as a live album and put on itunes, spotify etc. Incredible performance!!",
      "Imagine Bon Iver and Sigur rós in an album together",
      "The dislike button should be disabled for this masterpiece.",
      "The dude on drums plays with so much raw emotion",
      "This might be the most beautiful version of Creature Fear I've ever heard",
      "This is a masterpiece.",
      "His songs sound like someone accidentally fell on a piano but hit the perfect note.",
    ],
  },
  {
    artist: "Kraftwerk",
    id: "vNoFHdlMrtI",
    comments: [
      "I guess you guys aren't ready for that yet, but your kids are gonna love it!",
      "MUSIC NON STOP !!!!",
      "The faces on people wondering wtf is happening. Brilliant.",
      "Best Boiler Room ever!",
      "is this the future or the past????",
      "The Stone age of electronic music.",
      "the moment techno was born",
      "rave whistle was invented at this show",
      "The camera crew got a bit experimental also.",
      "Techno rave is made by Germany. First Base line ever.",
    ],
  },
  {
    artist: "Kylie Minogue",
    id: "xqtS6Meh5R4",
    comments: [
      "Madonna admires Kylie and Kylie admires madonna. Enough said. You both rock.",
      "This is the reason why she is so sucessful",
      "I'D SAY SHE IS THE QUEEN OF LIVE SHOWS :)",
      "Kylie is the Queen... <3",
      "Amazing gig she's so down to earth.",
      "Kylie the Diva! She can rock costumes like this and still look fabulous haha!",
      "Queen of pop with out a doubt",
      "the Best show girl !! ❤❤",
      "Kylie is a wonderful woman. She'll the queen of international super-POP, forever.",
      "Kylie rocks,amazing live performance!",
    ],
  },
  {
    artist: "Snoop Dogg",
    id: "6_h75JXBnSo",
    comments: [
      "how bout the band?! DAAAAAMN! Hope they're still the same members! The drummer and bass player were killin it!",
      "Nawww that dead crowd don't deserve Snoop",
      "Snoop dogg them damn musicians right man idk wat they was puffin on but damn boi",
      "The Drummer is so sickkkkkkk -",
      "Soopafly on the keyboard!",
      "No setlist because everyone watching this is high lol",
      "called it. Excellent performance.",
      "Snoop Killed It.",
      "i luv this guy no homo.... great show Uncle Snoop",
      "REST IN PEACE LOS (Drummer)",
    ],
  },
  {
    artist: "Harry Styles",
    id: "kxLG2yqTPWU",
    comments: [
      "hi, i'm harry styles, i'm sixteen, i work in a bakery\" iconic :)",
      "It’s just the cutest thing that Harry just introduces himself like no one knows who he is",
      "WHY IS THIS CROWD SO DRY I WOULD HAVE BEEN GOING OFF MY HEAD",
      "I think we all know that Harry is going to be remembered as another iconic English singer and I’m so happy to witness it lol",
      "The most amazing thing about Harry is that he needs no auto tune. His voice is so naturally beautiful and smooth. It’s crazy amazing",
      "Harry styles is someone no one can say anything negative about.",
      "I’m telling my kids this was Jesus Christ",
      "the dangerous thing about harry styles is that his looks are just a bonus",
      "I honestly cann't trust people who don' t like Harry styles",
      "this guy is just RIDICULOUSLY hot",
    ],
  },
  {
    artist: "Taylor Swift",
    id: "_t-fhPUPMrY",
    comments: [
      "The only reason why I wanna be rich is to afford to have Taylor Swift sing Lover live at my wedding reception. Periodttttt",
      "I wonder if Taylor’s parents realized they were making history when they bought her her first guitar",
      "i love that she always introduces herself like no one knows her",
      'I will never grow tired of Taylor introducing herself like, "hi, I am Taylor".',
      "She literally could turn any event into her concert",
      "CRUEL SUMMER, MISS AMERICANA & CORNELIA STREET DESERVES MOOOOORE",
      "She really does know how to interact with the audience & give meaningful, articulate speeches that people wouldn't get bored of.  Truly an icon.",
      "I'm so obsessed with her. Personality and music. She's the bomb.",
      "This girl is like wine: every year is better I mean prettier and as performer amazing",
      "She is the only artist who gave credit to the other co-artists while performing on stage.. I LOVE HER!!!!!!❤",
    ],
  },
  {
    artist: "Post Malone",
    id: "eCto5AUNfyo",
    comments: [
      "Circles is not just a song, it's an emotion.",
      "Posty really can’t make a bad song. Circles is so good!",
      "Circles is going to be a big hit when it officially comes out",
      "Goodbyes is such a good song, never hear anyone talk about how good it is",
      "Ummmmm is that Sublime as his Band???? WTF????? LEGENDARY POST!!!!!!!",
      "Feeling Whitney is so underrated. Especially this performance of the song is awesome",
      "Why is circles my favorite song and it isn’t even out yet",
      "Circles got that Fleetwood Mac vibe",
      "“White Iverson is probably my only good song”",
      'the dude on the back screaming "give him a cigarette" is a legend',
    ],
  },
  {
    artist: "Post Malone",
    id: "LRxYHsEJKgI",
    comments: [
      "hes like ready to bed then the organizer call him to perform on stage.",
      "Posty deserves better crowds than this man",
      "HE IS TOO NICE FOR THIS WORLD",
      "Post Malone is one of the most humble and nicest rappers out there! Truly cares about his fans...",
      "Only posty can perform with his Crocs in front of a huge crowd",
      "This makes me miss his curls so much",
      "posty so nice stopping the show to help someone",
      "Post malone wearing crocs in a concert",
      "I'm a fan of old school music but wen I come across this dude hes cool as",
      "“I love you” hahaha",
    ],
  },
  {
    artist: "Whitney Houston",
    id: "N5su1XtMMsM",
    comments: [
      "She was so amazing!",
      "She was soo  beautiful!",
      "Great!!!",
      "wowwww",
    ],
  },
  {
    artist: "Bob Marley",
    id: "bLkfzVSp49c",
    comments: [
      "He sings and tells a story of how we should all be. He knew about troubled times and he sang songs of One Love.",
      "My youngest son's name is 'Marley'.  Bob is a big deal in our house.  Awesome day!!",
      "What a powerful show! Amazings Bob Marley & The Wailers. Carlton Barret's drum work in this concert is exquisite, what great musicians !!",
      "I’m a massive Marley fan this is cool",
      "This man gave us the peace the world needed",
      "Bob marley will help us through this messy world at the moment",
      "Rise all freedom fighters",
      "The best of all times .",
      "We want to be free that's all",
      "Oh my gooooooood he is so extraordinary",
    ],
  },
  {
    artist: "Alicia Keys",
    id: "uJW69FjTu7o",
    comments: [
      "Love Alicia!",
      "Alicia is so different than any other artists and i like that unique style",
      "ALicia is incredible, emotional. Her music makes me feel shivers",
      "She loves to get outside the box.  Versatility.",
      "Alicia is the kind of artist where her music really speaks to you. For that, I love her so much!!",
      "An amazing person who has never lost touch with reality, whilst attaining momentous fame, and the most amazing singer ever.",
      "Love you Alicia!",
      "Her voice is so unique",
      "Alicia Keys can play the piano and sing at the same time",
      "This lady is awesome in every way",
    ],
  },
  {
    artist: "Damien Rice",
    id: "cL7QZv9wCZ8",
    comments: [
      "Cheers Darlin' is quite possibly the best musical autobiographical performance Ive ever seen.",
      "Rice is just genius personified.",
      "Incredible talent",
      "Amazing, what a showman!! he only needs a guitar, a piano and a glass of wine, no need of backup singers nor band.",
      'What a songwriter and performer... even "authentically drunk" :p. Thats taking your art seriously!',
      "I wonder what that Cheers Darlin girl would think if she heard it now.",
      "Damien Rice is not a Music artist Damien is the Music KING !!!!",
      "when i feel dead i play this and i feel a little alive",
      "I hope he gets royalties from Ed sheran",
      "one man on a stage with just a guitar. he is such a talent man",
    ],
  },
  {
    artist: "2CELLOS",
    id: "qew2m1UdbXk",
    comments: [
      "I just love to see all the happy people! Look at their faces: that’s how we all ought to look more often. Happiness to everyone!",
      "thanks for your music.",
      "Can we all just get an upvote for that epic drummer???",
      "under tremendous stress, accidentially found this. A real remedy. Thank you.",
      "This is the first time that music has touched my heart & soul --  like Freddie Mercury & Queen -- almost 50 years ago",
      "These two are real crazy and i really crazy love them.",
      "The Jimmy Hendrix of the Cello.  These 2 guys took their instruments to a new level..... Hendrix would approve!",
      "*NEVER IN HISTORY HAVE 2 CELLOS BEEN TOTALLY MASTERED LIKE THIS*",
      "simply magic!",
      "You bring my tears, timeless joy & more",
    ],
  },
  {
    artist: "2CELLOS",
    id: "CGU2BBeKaXM",
    comments: [
      "They are wonderful",
      "These guys are so incredible......I am stunned listening to them ...",
      "If these talented musicians don't move you, then you are dead inside.  Just. Magnificent. ♥♥♥♥♥♥♥♥♥♥",
      "it is almost impossible  to turn them off.",
      "The cello is my favourite instrument.",
      "im an AC/DC fan , and listening for the first time this group and they way they played the songs that i love ..just brilliant.... YOU GUYS ROCK!!!!!",
      "YOU'RE EXTREMELY AMAAAAAZIIIINGG!!!",
      "REALLY AWEEESOMEEE!!!!!",
      "I nevere thought that can be possible to play that Rock & roll music with cellos.",
      "These guys are outstanding..",
    ],
  },
  {
    artist: "2CELLOS",
    id: "Sk5zxA9UP2Q",
    comments: [
      "I think 2 CELLOS are the no 1 cello players in the world & I love 2 CELLOS",
      "stimulating and beautiful harmonic blend.",
      "They are fantastic!",
      "Amazing ..",
      "This is fantastic!!!",
      "This. Was. Stunning. Loved every bit",
      "A great mixture of passion and classic. Fabulous!",
      "Absolutely stunning musical performance by two marvelous young men.  An old lady said so!!",
      "GENIAL! 2 guys SO GENIUS. THE DIVINE HUMAN(ITY)! LOVE them",
      "Blessings to you both.",
    ],
  },
  {
    artist: "Edith Piaf",
    id: "O_ha3rustRw",
    comments: [
      "Elle est sans discussion possble la plus grande artiste de music hall en France.",
      "Edith é excelente!",
      "Magnifique !",
    ],
  },
  {
    artist: "New Order",
    id: "0Bu1fkgUM7s",
    comments: [
      "Stephen Paul David Morris = Human drum machine.",
      "I feel like crying when I hear Love Will Tear Us Apart by New Order, long live Joy Division forever.",
      "His voice has aged well. Still sounds like he's my age.",
      "They sound awesome. Still better then the majority of the crap put out today.",
      "One of the seminal connections between rock and electronic dance music. Still sounds relevant and great.",
      "When they play Joy Division songs is inpossible to me don't get emotional",
      "I love Joy Division and New Order.",
      "The only band that went through a time machine and brought  future to the past. Their music is way ahead of their time. NEW ORDER FOREVER!",
      "Absolutely brilliant. Keep coming back for more. Really good gig.",
      "I just love the way Bernard laughs at himself after realizing he screwed up the lyrics.",
    ],
  },
  {
    artist: "Peggy Gou",
    id: "-UOMvxh4MYU",
    comments: [
      "cellphones people, why would you film it when its live and also recorded?",
      "I would be so paranoid about the sculptures in danger...",
      "What a beautiful place to play.",
      "Mixing or not, I'm liking this",
      "Track is pure beats",
      "My new favourite set!",
      "omg i love her already, she is killing it",
      "All those Smartphone Apes in the Crowd omfg....",
      "I really love, that she's playin also the old stuff from the 90'. Makes me feel young again :)",
      "The most beautiful woman on the planet slaying the game.",
    ],
  },
  {
    artist: "Peggy Gou",
    id: "nKHpbiYCtDQ",
    comments: [
      "Out to Peggy Gou / Peggy Shoe / Peggy Boo (depending on drunkness)",
      "Bruce Willis has quite a good taste in music",
      "I DIED DEAD.",
      "I think Peggy is cool.",
      "just here for all the men with subpar mixing skills analyzing her set",
      "i respect the black clout goggles",
      "what a set peggy...",
      "She’s so cute",
      "anyone noticing kids on her back, i think they lost from their parent",
    ],
  },
];
